import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>UCZELNIE SZKOŁOM</h1>
                <h2>o finansach z NBP</h2>
            </header>
            <div className="content">
                <p>Projekt Podhalańskiej Państwowej Uczelni Zawodowej w Nowym Targu realizowany z <strong>Narodowym&nbsp;Bankiem&nbsp;Polskim</strong> w ramach programu edukacji ekonomicznej.</p>
                <ul className="actions">
                    <li><a href="#one" className="button next scrolly">Zapraszamy</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner
